export default {
  fillRequiredFields: "Fill all required fields."
}
